// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Container component
 */

/**
 * This component is intended to show only report part content.
 * Parameters locate in the params property:
   * id: required. Id of report part.
   * filter: is an array of Object with key and	value
   * previewRecords: > 0 valid number, get number of records; < 0 invalid number; -1 get all records
   * 	for Example:
   *  "id": "554D4D2F-E12A-4680-A2EC-A405DE872B7F",
   *  "filters": [
	              {
	                key: "[northwind].[dbo].[Order Details].[ProductID]",
	                value: 5
	              }
               ],
   *  "previewRecords": 100
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import subReportLink from 'share/utils/Izenda.SubReportLink';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import ReportPartFrontSideViewer from 'modules/ReportDesigner/Fields/ReportBody/ReportPartFrontSideViewer/Izenda.ReportPartFrontSideViewer';
import IntegrationContainer from '../Izenda.IntegrationContainer';
import queryString from 'query-string';
import IntergrateStore from 'share/utils/Izenda.IntergrateStore';
import Integration from 'config';
import { flow, pick, merge, toLower } from 'lodash/fp';
export default class ReportPartPage extends Component {
  static propTypes = {
    params: PropTypes.object
  };

  componentWillUnmount() {
    IntergrateStore.removePart(this.props.params.id);
  }

  render() {
    const { params } = this.props;
    let childProps = {
      reportPartId: params.id,
      publishDrillInfo: params.publishDrillInfo,
      crosssfilters: params.crosssfilters,
      previewRecords: params.previewRecords
    };

    Integration && (childProps.page = IntergrateStore.syncPageManifest());
    let query = {};
    let printingMode = false;

    if (params.useQueryParam) {
      if (params.useHash) {
        query = routeUtils.getHashLocation().query;
      } else {
        query = queryString.parse(location.search);
      }

      printingMode = toLower(query.print) === 'true';

      childProps = flow(
        pick(['width', 'height', 'hideTitle', 'separator', 'pageNumber', 'elementsCountInContainer']),
        merge(childProps),
        merge({
          printingMode,
          location: location,
          subReportFilterFromQuery: subReportLink.convertQueryToFilter(query),
          forExporting: !!query.width && !!query.height,
          query: query,
          intergrateMode: true
        })
      )(query);
    } else {
      childProps = merge(childProps, {
        subReportFilter: {
          filters: params.filters,
          overridingFilterValue: params.overridingFilterValue
        }
      });
    }

    return (
      <IntegrationContainer printingMode={printingMode}>
        <ReportPartFrontSideViewer containerSizeFixed={false} {...childProps} />
      </IntegrationContainer>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/pages/Izenda.ReportPartPage.js